<template>
    <FullDashboard v-if="can('view dashboard') && organizationSlug" />
    <MinimalDashboard v-else-if="user.organization_id" />
    <ErrorDashboard v-else />
</template>

<script>
import FullDashboard from '@/views/app/dashboard/full.vue'
import MinimalDashboard from '@/views/app/dashboard/minimal.vue'
import ErrorDashboard from '@/views/app/dashboard/error.vue'
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'
import Permissions from '@/mixins/permissions'

export default {
    components: {
        FullDashboard,
        MinimalDashboard,
        ErrorDashboard,
    },

    mixins: [needsOrganizationSlug, Permissions],

    data() {
        return {
            user: this.$store.getters.user,
        }
    },
}
</script>

<style scoped lang="scss"></style>
